import { render, staticRenderFns } from "./lawcaseLayout.vue?vue&type=template&id=8d71d170&scoped=true&"
import script from "./lawcaseLayout.vue?vue&type=script&lang=js&"
export * from "./lawcaseLayout.vue?vue&type=script&lang=js&"
import style0 from "./lawcaseLayout.vue?vue&type=style&index=0&id=8d71d170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d71d170",
  null
  
)

export default component.exports